import React from "react";
import { ReactNode } from "react";
import AppFooter from "./AppFooter";
import { Container } from "@chakra-ui/layout";
import AppHeader from "./AppHeader/AppHeader";
import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Link,
} from "@chakra-ui/react";
import { messages } from "../messages";

interface IAppWrapper {
  children: ReactNode | ReactNode[];
}

const AppWrapper: React.FC<IAppWrapper> = ({ children }: IAppWrapper) => {
  const renderMessages = (): JSX.Element => {
    return (
      <>
        {messages.map((message, index) => {
          return (
            <Alert
              key={index}
              status={message.status}
              colorScheme={message.colorScheme}
              mb={0}
              variant={message.variant}
              color={message.color}
            >
              <AlertIcon />
              <Box>
                <AlertDescription>
                  {message.content}
                  {message.link && (
                    <>
                      <br />
                      {message.link.description}
                    </>
                  )}
                </AlertDescription>{" "}
                {message.link && (
                  <>
                    <Link
                      href={message.link.href}
                      isExternal
                      style={{ textDecoration: "underline" }}
                    >
                      {message.link.text}
                    </Link>
                    .
                  </>
                )}
              </Box>
            </Alert>
          );
        })}
      </>
    );
  };

  return (
    <Container px={0} maxWidth={"full"} minW={"full"}>
      <AppHeader />
      {renderMessages()}
      {children}
      <AppFooter />
    </Container>
  );
};

export default AppWrapper;
